import { Link } from "react-router-dom"; // Move import to the top
import { useState } from "react";

const MobileMenu = ({ isSidebar, handleMobileMenu, handleSidebar }) => {
  const [isActive, setIsActive] = useState({
    status: false,
    key: "",
    subMenuKey: "",
  });

  const handleToggle = (key, subMenuKey = "") => {
    if (isActive.key === key && isActive.subMenuKey === subMenuKey) {
      setIsActive({
        status: false,
        key: "",
        subMenuKey: "",
      });
    } else {
      setIsActive({
        status: true,
        key,
        subMenuKey,
      });
    }
  };

  return (
    <>
      {/*Mobile Menu */}
      <div className="mobile-menu">
        <div className="menu-backdrop" onClick={handleMobileMenu}></div>
        <div className="close-btn" onClick={handleMobileMenu}>
          <i className="fal fa-times"></i>
        </div>

        <nav className="menu-box">
          <div className="nav-logo">
            <Link to="/">
              <img src="assets/images/newLogo.png" alt="" />
            </Link>
          </div>
          {/*menu-outer*/}
          <div className="menu-outer">
            <div
              className="collapse navbar-collapse show clearfix"
              id="navbarSupportedContent"
            >
              <ul className="navigation clearfix">
                <li className={isActive.key === 1 ? "dropdown current" : "dropdown"}>
                  {/* <Link to="/" onClick={handleMobileMenu}>
                    Home
                  </Link> */}

                  <a href="https://newranss.com.au/#banner">Home</a>
       
                </li>

                <li >
                <a href="https://services.newranss.com.au">Services</a>

              
                </li>
                <li >
                <a href="https://referrals.newranss.com.au">Referrals</a>

              
                </li>

                {/* <li className={isActive.key === 3 ? "dropdown current" : "dropdown"}>
                  <Link to="/living-option" onClick={handleMobileMenu}>
                    Living Options
                  </Link>
                  <ul style={{ display: `${isActive.key === 3 ? "block" : "none"}` }}>
                    <li>
                      <Link to="/living-option" onClick={handleMobileMenu}>
                        Living Option
                      </Link>
                    </li>
                    <li>
                      <Link to="/living-option-details" onClick={handleMobileMenu}>
                        Living Option Details
                      </Link>
                    </li>
                  </ul>

                  <div
                    className={isActive.key === 3 ? "dropdown-btn open" : "dropdown-btn"}
                    onClick={() => handleToggle(3)}
                  >
                    <span className="fa fa-angle-right" />
                  </div>
                </li> */}

                {/* Other Menu Items */}
                {/* Repeat the above structure for other menu items as needed */}
              </ul>
            </div>
          </div>

          <div className="social-links">
            <ul className="clearfix">
              <li>
                <Link to="/">
                  <span className="fab fa-twitter"></span>
                </Link>
              </li>
              <li>
                <Link to="/">
                  <span className="fab fa-facebook-square"></span>
                </Link>
              </li>
              <li>
                <Link to="/">
                  <span className="fab fa-pinterest-p"></span>
                </Link>
              </li>
              <li>
                <Link to="/">
                  <span className="fab fa-instagram"></span>
                </Link>
              </li>
              <li>
                <Link to="/">
                  <span className="fab fa-youtube"></span>
                </Link>
              </li>
            </ul>
          </div>
        </nav>
      </div>
      {/*End Mobile Menu */}

      <div
        className="nav-overlay"
        style={{ display: `${isSidebar ? "block" : "none"}` }}
        onClick={handleSidebar}
      />
    </>
  );
};

export default MobileMenu;
